import React from 'react'
import classes from './veryNewProposalDesign.module.scss';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReactGA from "react-ga4";
import { EmailSvg, LocationSvg, PhoneSvg } from '../../constants/resources';



interface props {
  data: any
  name?: string
}
const InformationContainer: React.FC<props> = ({ data, name }) => {


  const Maps = (node: string, place: string) => {
    ReactGA.event({
      category: "Map",
      action: `Clicked Map ${place}`,
    });
    window.open("https://www.google.com/maps/search/" + node);
  };

  const checkSpacing = (node: any) => {
    let text: any;
    if (node !== null) {
      text = node
      text = text.replaceAll("&nbsp;", "");
      text = text.replace(/<[^>]+>/g, "");
      if (text.trim() === "") {


        return false
      } else {
        return true
      }
    }
    else return false

  }

  return (
    <div>
      {name ?
        data?.importantInformations?.map((node: any) => {
          return node.type === name ? <div className={classes.InformationContainer}>
            <div className={classes.InformationContainerHeader}>
              <InfoOutlinedIcon style={{ color: "0279CF" }} />
              <div className={classes.subHeader}> Information</div>
            </div>
            {
              !node?.information ?
                <div style={{ fontSize: "12px", color: "lightgray", fontStyle: "italic" }}>
                  No information available {name}
                </div> :

                <div className={classes.InfoText}>
                  {node?.information}
                </div>
            }

            <div className={classes.subHeader}>Contact details</div>
            <div className={classes.InfoText} style={{ display: "flex", flexDirection: "row", margin: "5px 0px" }}>
              <div style={{ width: "130px" }}>Email</div>
              {node?.email ?
                <span style={{ color: "#0279CF" }}>{node?.email}</span> :
                <div style={{ fontSize: "12px", fontStyle: "italic", color: "lightgray" }}>No email available</div>
              }
            </div>
            <div className={classes.InfoText} style={{ display: "flex", flexDirection: "row", margin: "5px 0px" }}>
              <div style={{ width: "130px" }}>Phone number</div>
              {
                node?.contact ?
                  <span style={{ color: "#0279CF" }}>{node?.contact}</span> :
                  <div style={{ fontSize: "12px", fontStyle: "italic", color: "lightgray" }}>No Phone number available</div>
              }
            </div>
          </div> : null
        })
        : <div className={classes.InformationContainer}>
          <div style={{ display: 'flex', flexDirection: 'column', width: '60%' }}>
            <div className={classes.InformationContainerHeader}>
              <InfoOutlinedIcon style={{ color: "0279CF" }} />
              <div className={classes.subHeader}> Information</div>
            </div>
            {
              !checkSpacing(data?.description) ?
                <div style={{ fontSize: "12px", color: "lightgray", fontStyle: "italic" }}>
                  No description available
                </div> :

                <div dangerouslySetInnerHTML={{ __html: data?.description }} className={classes.InfoText}>
                </div>
            }
            <br />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
            <div className={classes.subHeader}>Contact information</div>
            <div className={classes.InfoText} style={{ display: "flex", flexDirection: "row", margin: "5px 0px" }}>
              {data?.email && <div style={{ width: "38px" }}><div className={classes.featureIcon}>
                <EmailSvg />
              </div>
              </div>}
              {data?.email &&
                <span style={{ color: "#758191", wordBreak: 'break-word' }}>{data?.email}</span>
              }
            </div>
            <div className={classes.InfoText} style={{ display: "flex", flexDirection: "row", margin: "5px 0px" }}>
              <div style={{ width: "38px" }}><div className={classes.featureIcon}>
                <PhoneSvg />
              </div>
              </div>
              {
                data?.phone ?
                  <span style={{ color: "#758191" }}>{data?.phone}</span> :
                  <div style={{ fontSize: "12px", fontStyle: "italic", color: "lightgray" }}>No Phone number available</div>
              }
            </div>

            <div className={classes.InfoText} onClick={() => Maps((data.street + "," + data.street2 + "," + data.city + "," + data.stateProvince + "," + data.zip + "," + data.country), "Accommodation Address ")} style={{ display: "flex", flexDirection: "row", margin: "5px 0px", cursor: 'pointer' }}>
              <div style={{ width: "38px" }}><div className={classes.featureIcon}>
                <LocationSvg width={"13px"} height={"12px"} />
              </div>
              </div>
              {data.street || data.street2 || data.city || data.stateProvince || data.zip || data.country ? <span style={{ color: "#758191" }}

              >{data.street},{data.street2},{data.city},{data.stateProvince},{data.zip},{data.country}</span>
                :
                <div style={{ fontSize: "12px", fontStyle: "italic", color: "lightgray" }}>No address available</div>}
            </div>
          </div>
        </div>}
    </div>
  )
}

export default InformationContainer
